<template>
    <div class="admin admin-public-part-lot">
      <p class="admin-title a-flex-start align-items-baseline">
        {{$t('form.lot.lot-title', {number: lot.permissions.CAN_SEE_PUBLIC_LOT_STATISTICS?lot.id:lot.identifier})}}
        <button class="gui-btn gui-btn--white-border gui-btn--w-230 u-margin-left-20" type="button" @click="onAddToFavoritesClick" v-if="!isInFavorites">{{$t('buttons.save-lot-to-favorites')}}</button>
        <button class="gui-btn gui-btn--white-border gui-btn--w-230 u-margin-left-20" type="button" @click="onRemoveFromFavoritesClick" v-else>{{$t('buttons.remove-lot-from-favorites')}}</button>
        <span v-if="lot.permissions.CAN_VIEW_VOTING_RESULTS">
          <router-link :to="{name: 'purchases-lot-details', params: { lotId: lot.id, tab: 'overview'}}"
                       class="gui-btn gui-btn--red gui-btn--w-300 u-margin-left-20">
            В форму формирования лота
          </router-link>
          <router-link :to="{name: 'purchases-tender-details', params: { tenderId: lot.tenderId, tab: 'overview'}}"
                       class="gui-btn gui-btn--red gui-btn--w-300 u-margin-left-20 u-margin-top-13">
            В форму формирования извещения
          </router-link>
        </span>
      </p>

      <div class="a-tab" id="accordion-tab">
        <div class="a-tab__control u-margin-b-24">
          <router-link to="overview" tag="button" type="button" class="a-tab__btn" active-class="a-active " >{{$t('form.lot.basic-data')}}</router-link>

          <template v-if="lot.request && lot.request.permissions.HAS_ACCREDITATION" >
            <router-link to="request" tag="button" type="button" class="a-tab__btn" active-class="a-active " v-if="lot.request.state.EMPTY">{{$t('form.lot.send-request')}}</router-link>
            <router-link to="request" tag="button" type="button" class="a-tab__btn" active-class="a-active " v-else>{{$t('form.lot.request')}} {{lot.catalog.name}}-{{lot.request.id}}</router-link>
          </template>

          <router-link to="discussion" tag="button" type="button" class="a-tab__btn" active-class="a-active" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_COMMENTS">{{$t('form.lot.lot-discussion')}}</router-link>

          <router-link to="specification" tag="button" type="button" class="a-tab__btn" active-class="a-active" v-if="!lot.request || lot.request.state.EMPTY">{{$t('form.lot.specification')}}</router-link>
          <router-link :to="bid.tab" tag="button" type="button" class="a-tab__btn" active-class="a-active" v-else v-for="bid in bids" :key="bid.id">{{$t('form.lot.bid', {id: bid.num})}}</router-link>

          <router-link to="reduction" tag="button" type="button" class="a-tab__btn" active-class="a-active" v-if="lot.permissions.CAN_SEE_REDUCTION_TAB">{{$t('form.lot.reduction')}}</router-link>
        </div>

        <div class="collapse show" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
          <section class="human-data">
            <!-- Overview tab -->
            <template v-if="showOverview">
              <overview :lot="lot" ></overview>
              <documents :lot="lot" v-if="showDocuments"></documents>
              <protocols :lot="lot" v-if="showProtocols"></protocols>
<!--              <reduction-result :lot="lot" v-if="lot.reductionResult.length > 0"></reduction-result>-->
              <requests :lot="lot" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ALL_REQUESTS"></requests>
              <bids-history :lot="lot" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_BIDS_HISTORY"></bids-history>
            </template>

            <lot-specification :lot="lot" v-if="showSpecification"></lot-specification>

            <!-- Request tab -->
            <template v-if="showRequest">
              <my-request :lot="lot" v-if="lot.request.permissions.HAS_ACCREDITATION" ></my-request>
            </template>

            <lot-discussion :lot="lot" v-if="showDiscussion"></lot-discussion>

            <template v-if="showReduction">
              <reduction :lot="lot"></reduction>
            </template>

            <template v-for="bid in bids">
              <bid-overview :lot="lot"
                            :bid="bid.bid"
                            :key="bid.bid.id"
                            v-if="showBid && bid.tab === requestedBid"></bid-overview>
            </template>
          </section>
        </div>
      </div>
    </div>
</template>

<script>
  import _ from 'lodash'

  import Overview from './Overview'
  import Documents from './Documents'
  import Protocols from './Protocols'
  import MyRequest from './MyRequest'
  import Requests from './Requests'
  import LotDiscussion from './LotDiscussion'
  import BidOverview from './BidOverview'
  import BidInRequest from './request/BidInRequest';
  import LotSpecification from './LotSpecification'
  import Reduction from './reduction/Main'
  import BidsHistory from "./BidsHistory";
  import ReductionResult from "./ReductionResult";

  export default {
    props: {
      lot: Object
    },

    components: {
      BidInRequest,
      Overview,
      Documents, Protocols, MyRequest, Requests, LotDiscussion, BidOverview,LotSpecification,
      Reduction,
      BidsHistory,
      ReductionResult
    },

    mounted() {
      this._autoUpdateTimer = setInterval(async() => {
        try {
          if (this.lot.state.RETEND || this.lot.state.WAITING_FOR_RETEND) {
            await this.$store.dispatch('checkPublicLot', {
              lotId: this.lot.id
            });
          }
        }
        catch(e) {
          console.log('failed public lot watcher', e);
          clearInterval(this._autoUpdateTimer);
        }
      }, 10000);
    },

    beforeDestroy() {
      clearInterval(this._autoUpdateTimer);
    },

    computed: {
      showOverview() {
        return this.$route.params.tab === 'overview';
      },

      showDocuments() {
        return this.$route.params.tab === 'overview';
      },

      showProtocols() {
        return this.$route.params.tab === 'overview' && this.lot.permissions.CAN_SEE_PUBLIC_LOT_PROTOCOLS;
      },

      showRequest() {
        return this.$route.params.tab === 'request'
      },

      showDiscussion() {
        return this.$route.params.tab === 'discussion'; //&& this.lot.permissions.CAN_SEE_PUBLIC_LOT_COMMENTS;
      },

      showSpecification() {
        return this.$route.params.tab === 'specification'
      },

      showReduction() {
        return this.$route.params.tab === 'reduction'
      },

      isBidRequested() {
        return this.$route.params.tab.indexOf('bid') === 0;
      },

      showBid() {
        let bid = _.find(this.bids, bid => {
          return bid.tab === this.$route.params.tab
        });

        return bid;
      },

      isInFavorites() {
        return !!_.find(this.$store.getters.currentUser.favorites, { id: this.lot.id });
      },

      requestedBid() {
        return this.$route.params.tab;
      },

      bids() {
        let tabs = [];

        if (this.lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST && this.lot.request.bids.length > 0) {
          tabs = this.lot.request.bids.map((b, i) => ({
            tab: 'bid-' + b.id,
            bid: b,
            id: b.id,
            idx: i,
            num: b.num
          }));
        }

        return tabs;
      }
    },

    created() {
      if (this.showRequest && !this.lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST) {
        // user has not required permission, let's redirect to overview tab
      }

      if (this.showDiscussion && !this.lot.permissions.CAN_SEE_PUBLIC_LOT_COMMENTS) {
        // user has not required permission, let's redirect to overview tab
      }

      if (this.isBidRequested && (!this.showBid || !this.lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST)) {
        // user has not required permission, let's redirect to overview tab
      }
    },

    methods: {
      async onAddToFavoritesClick() {
        try {
          await this.$store.dispatch('addLotToFavorites', this.lot);
        }
        catch(e) {
          console.error('failed adding lot to favorites', e);
          this.globalErrorHandler(e);
        }
      },

      async onRemoveFromFavoritesClick() {
        try {
          await this.$store.dispatch('removeLotFromFavorites', this.lot);
        }
        catch(e) {
          console.error('failed removing lot from favorites', e);
          this.globalErrorHandler(e);
        }
      }
    }
  }
</script>

<style>
  .a-tab__btn {
    color: #4C4C4C;
    border-bottom: 1px solid transparent;
  }

  .a-tab__btn.a-active {
    color: #E30613;
    border-bottom: 1px solid #E30613;
  }
</style>
